"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfProductOverviewSearchModel = instanceOfProductOverviewSearchModel;
exports.ProductOverviewSearchModelFromJSON = ProductOverviewSearchModelFromJSON;
exports.ProductOverviewSearchModelFromJSONTyped = ProductOverviewSearchModelFromJSONTyped;
exports.ProductOverviewSearchModelToJSON = ProductOverviewSearchModelToJSON;
exports.ProductOverviewSearchModelToJSONTyped = ProductOverviewSearchModelToJSONTyped;
/**
 * Check if a given object implements the ProductOverviewSearchModel interface.
 */
function instanceOfProductOverviewSearchModel(value) {
    return true;
}
function ProductOverviewSearchModelFromJSON(json) {
    return ProductOverviewSearchModelFromJSONTyped(json, false);
}
function ProductOverviewSearchModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'orderString': json['orderString'] == null ? undefined : json['orderString'],
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'no': json['no'] == null ? undefined : json['no'],
        'name': json['name'] == null ? undefined : json['name'],
        'tagName': json['tagName'] == null ? undefined : json['tagName'],
        'tagId': json['tagId'] == null ? undefined : json['tagId'],
        'member': json['member'] == null ? undefined : json['member'],
    };
}
function ProductOverviewSearchModelToJSON(json) {
    return ProductOverviewSearchModelToJSONTyped(json, false);
}
function ProductOverviewSearchModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'orderString': value['orderString'],
        'currentPage': value['currentPage'],
        'pageSize': value['pageSize'],
        'no': value['no'],
        'name': value['name'],
        'tagName': value['tagName'],
        'tagId': value['tagId'],
        'member': value['member'],
    };
}
